// Users.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { url } from "../Api/config";

const Users = () => {
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sortConfig, setSortConfig] = useState({ key: "id", direction: "asc" }); // изначальная сортировка по ID
    const [filters, setFilters] = useState({
        labs: true,
        doctors: false,
        technics: false,
    });

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });

        const sortedUsers = [...filteredUsers].sort((a, b) => {
            let aValue = a[key] || "";
            let bValue = b[key] || "";

            if (key === "date_pay") aValue = aValue ? new Date(aValue) : new Date(0);
            if (key === "amount") aValue = Number(aValue) || 0;
            if (key === "amount") bValue = Number(bValue) || 0;
            if (key === "date_pay") bValue = bValue ? new Date(bValue) : new Date(0);

            if (aValue < bValue) return direction === "asc" ? -1 : 1;
            if (aValue > bValue) return direction === "asc" ? 1 : -1;
            return 0;
        });

        setFilteredUsers(sortedUsers);
    };

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await axios.post(`${url}/api/getusers`, {});
                if (res.data && res.data.users) {
                    const sorted = [...res.data.users].sort((a, b) => a.id - b.id);
                    setUsers(sorted);
                    setFilteredUsers(sorted);
                } else {
                    setUsers([]);
                    setFilteredUsers([]);
                }
            } catch (err) {
                console.error("Ошибка при загрузке пользователей:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, []);

    // применяем фильтры при изменении
    useEffect(() => {
        let newUsers = users.filter((user) => {
            if (filters.labs && !user.is_doctor && !user.is_technic) return true;
            if (filters.doctors && user.is_doctor) return true;
            if (filters.technics && user.is_technic) return true;
            return false;
        });

        // сортируем по текущему состоянию sortConfig
        if (sortConfig.key) {
            newUsers = [...newUsers].sort((a, b) => {
                let aValue = a[sortConfig.key] || "";
                let bValue = b[sortConfig.key] || "";

                if (sortConfig.key === "date_pay") aValue = aValue ? new Date(aValue) : new Date(0);
                if (sortConfig.key === "amount") aValue = Number(aValue) || 0;
                if (sortConfig.key === "amount") bValue = Number(bValue) || 0;
                if (sortConfig.key === "date_pay") bValue = bValue ? new Date(bValue) : new Date(0);

                if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
                if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
                return 0;
            });
        }

        setFilteredUsers(newUsers);
    }, [filters, users, sortConfig]);

    const toggleFilter = (key) => {
        setFilters((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    if (loading) return <p>Загрузка пользователей...</p>;

    return (
        <div style={{ padding: "20px", maxHeight: "600px", overflowY: "auto", border: "1px solid #ccc" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <label style={{fontSize: '12px'}}>Записей: ({filteredUsers.length})</label>
                {/* <div>
                    <label style={{ marginRight: "10px" }}>
                        <input
                            type="checkbox"
                            checked={filters.labs}
                            onChange={() => toggleFilter("labs")}
                        />{" "}
                        Лаборатории
                    </label>
                    <label style={{ marginRight: "10px" }}>
                        <input
                            type="checkbox"
                            checked={filters.doctors}
                            onChange={() => toggleFilter("doctors")}
                        />{" "}
                        Врачи
                    </label>
                    <label>
                        <input
                            type="checkbox"
                            checked={filters.technics}
                            onChange={() => toggleFilter("technics")}
                        />{" "}
                        Техники
                    </label>
                </div> */}
            </div>

            {filteredUsers.length === 0 ? (
                <p>Нет пользователей</p>
            ) : (
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        backgroundColor: "#f7f7f7",
                    }}
                >
                    <thead
                        style={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "#e0e0e0",
                            zIndex: 2,
                        }}
                    >
                        <tr>
                            <th style={thStyle}>№</th>
                            <th style={thStyle} onClick={() => handleSort("id")}>ID</th>
                            <th style={thStyle}>Аватар</th>
                            <th style={thStyle} onClick={() => handleSort("surname")}>ФИО</th>
                            <th style={thStyle} onClick={() => handleSort("email")}>Email</th>
                            <th style={thStyle} onClick={() => handleSort("is_doctor")}>Доктор</th>
                            <th style={thStyle} onClick={() => handleSort("is_technic")}>Техник</th>
                            <th style={thStyle} onClick={() => handleSort("description")}>Подписка</th>
                            <th style={thStyle} onClick={() => handleSort("date_pay")}>Дата платежа</th>
                            <th style={thStyle} onClick={() => handleSort("amount")}>Сумма</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUsers.map((user, index) => (
                            <tr key={user.id} style={trStyle}>
                                <td style={{ ...tdStyle, color: "green" }}>{index + 1}</td>

                                <td style={tdStyle}>{user.id}</td>
                                <td style={tdStyle}>
                                    {user.photo_path ? (
                                        <img
                                            src={`${url}/api/static/uploads/${user.photo_path}`}
                                            alt="avatar"
                                            style={{ width: 50, height: 50, borderRadius: "50%" }}
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                width: 50,
                                                height: 50,
                                                borderRadius: "50%",
                                                backgroundColor: "#ccc",
                                            }}
                                        />
                                    )}
                                </td>
                                <td style={tdStyle}>
                                    {user.surname} {user.name}
                                </td>
                                <td
                                    style={{
                                        ...tdStyle,
                                        width: "300px",
                                        wordBreak: "break-word",
                                    }}
                                >
                                    {user.email}
                                </td>
                                <td style={tdStyle}>{user.is_doctor ? "Да" : "Нет"}</td>
                                <td style={tdStyle}>{user.is_technic ? "Да" : "Нет"}</td>
                                <td style={tdStyle}>{user.description || "—"}</td>
                                <td style={tdStyle}>
                                    {user.date_pay ? new Date(user.date_pay).toLocaleDateString() : "—"}
                                </td>
                                <td style={tdStyle}>{user.amount || "—"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

// стили для таблицы
const thStyle = {
    padding: "10px",
    textAlign: "left",
    borderBottom: "1px solid #ccc",
    cursor: "pointer",
};

const tdStyle = {
    padding: "8px",
    borderBottom: "1px solid #ddd",
};

const trStyle = {
    backgroundColor: "#fafafa",
};

export default Users;
